<div class="header">
  <p-toolbar styleClass="p-0 h-[56px]">
    <ng-template pTemplate="start">
      @if(!brandLogo()){
        <p-skeleton height="20px" width="90px" class="py-2 w-full" />
      } @else {
        <img class="logo" i18n-alt="@@alt.logo" alt="logo" [src]="brandLogo()" />
      }
    </ng-template>
    <ng-template pTemplate="end">
      <div class="flex items-center pr-4 gap-4 mt-1">
        <p-button
          i18n-ariaLabel="@@aria.label.user.profile.menu"
          ariaLabel="menu"
          (onClick)="userProfileMenu.toggle($event)"
          [link]="true"
          styleClass="p-0 overflow-visible inline-flex items-center justify-center"
        >
          <p-avatar class="inline-flex items-center justify-center" shape="circle">
            <svg-icon class="inline-flex items-center justify-center leading-none align-middle" svgClass="icon-32" src="/assets/icons/profile.svg" />
          </p-avatar>
        </p-button>
        <p-menu id="header-user-actions" #userProfileMenu class="userProfileMenu" [model]="userProfileMenuItems" [popup]="true">
          <!-- <ng-template pTemplate="end">
                        <div class="profile-menu-end relative overflow-hidden w-full p-link flex align-items-center p-2 pl-3 text-color hover:surface-200 rounded-none border-top">
                            <p-avatar [label]="userDetails.userName ? userDetails.userName.charAt(0).toUpperCase() : ''" class="mr-2" styleClass="bg-blue-200"
                                      shape="circle"/>
                            <span class="inline-flex flex-column">
                                <span class="font-bold">{{ userDetails.firstName }}&nbsp;{{userDetails.lastName}}</span>
                                <span class="text-sm">{{ userDetails.userName }}</span>
                            </span>
                        </div>
                    </ng-template> -->
        </p-menu>
        <!-- <p-button [link]="true" styleClass="p-0">
                    <p-avatar class="flex items-center" shape="circle">
                        <svg-icon svgClass="icon-32" src="/assets/icons/notification-bell.svg" />
                    </p-avatar>
                </p-button> -->
        @if(!this.unauthorizedAccess){
        <p-button
          i18n-ariaLabel="@@aria.label.publisher.panel"
          ariaLabel="Publisher Panel"
          (onClick)="openPanel()"
          [link]="true"
          class="overflow-visible"
          styleClass="p-0 overflow-visible inline-flex items-center justify-center"
        >
          <div class="relative inline-flex items-center">
          <p-avatar class="inline-flex items-center justify-center" shape="circle">
            <svg-icon class="inline-flex items-center justify-center leading-none align-middle" svgClass="icon-32" src="/assets/icons/publisher.svg" />
          </p-avatar>
          @if(notification()){
            <p-badge class="absolute top-[5px] right-[2px]"/>
          }
          </div>
        </p-button>
        <p-popover [dismissable]="false" [styleClass]="'publisher-popover custom-overlay-position'" #overlayPanel>
          <app-publisher #publisherContent (dialogEvent)="overlayPanel.hide()" (notification)="updateNotification($event)" />
        </p-popover>
        }
        <!-- language toogle here for now -->
        <!-- <div class="text-center gs-table-action-icon">
          <p-menu id="storefront-actions" #actionsmenu [model]="actionItems" styleClass="bg-white" [popup]="true" appendTo="body"> </p-menu>
          <p-button
            i18n-ariaLabel="@@aria.label.header.menu"
            ariaLabel="menu"
            [link]="true"
            size="small"
            styleClass="p-0"
            (onClick)="actionsmenu.toggle($event)"
          >
            <svg-icon class="icon-32 gs-text-black" src="/assets/icons/menu-additional-horizontal.svg" />
          </p-button>
        </div> -->
      </div>
    </ng-template>
  </p-toolbar>
</div>

<app-dialog
  dialogId="signOutConfirmDialog"
  [title]="this.title"
  [content]="this.content"
  [btnName]="this.signOut"
  [dialogHeader]="this.signOut"
  (onSuccess)="logout()"
  [cancelBttnText]="this.cancelBtn"
></app-dialog>
